// ProgressBar.js
import React from "react";
import { Progress } from "antd";

const ProgressBar = (props) => {
  const { capacity, estimation, showInfo, size, sx } = props;

  // Calculate the percentage
  const percent = (capacity / estimation) * 100;

  // Determine the status based on capacity
  let status;
  if (capacity > estimation) {
    status = "exception";
  } else {
    status = "normal";
  }

  return (
    <div style={{ alignItems: "center" }}>
      <p
        style={{
          fontSize: "11px",
          fontWeight: "bold",
          lineHeight: "0px",
          letterSpacing: "0px",
          textAlign: "right",
          marginBlock: "0px",
        }}
      >
        {capacity}hrs/{estimation}hrs{" "}
      </p>
      <Progress
        percent={percent}
        status={status}
        showInfo={showInfo}
        size={size}
        sx={sx}
      />
    </div>
  );
};

export default ProgressBar;
